import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { StringCustomControlProps } from "../../Utils/Interfaces";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { Maybe } from "../../sharedCode/avroGraphql";
import { getHelperText, propertyHasErrors } from "./inputHelpers";

function limitValue(value: string | null | undefined, maxLength?: number): string {
    const next = value ?? "";
    return maxLength != null ? next.slice(0, maxLength) : next;
}

export default function EmailAddressEditor(props: StringCustomControlProps): JSX.Element {
    const [localValue, setLocalValue] = useState<Maybe<string>>(limitValue(props.initialValue ?? "", props.maxLength));

    const handleOnChange = (value: string | null): void => {
        setLocalValue(limitValue(value, props.maxLength));
    };

    const handleOnBlur = (value: string | null): void => {
        // TODO ROUTING add email address validation
        const limited = limitValue(value, props.maxLength);
        if (limited !== (props.initialValue ?? "")) {
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: limited || undefined });
        }
    };

    return (
        <>
            <TextField
                margin={CONTROL_MARGIN}
                fullWidth
                label={props.labelText}
                value={localValue ?? ""}
                inputProps={{
                    autoCapitalize: "none",
                    autoCorrect: "off",
                    inputMode: "email",
                    ...(props.maxLength != null ? { maxLength: props.maxLength } : {}),
                }}
                onChange={(e) => {
                    handleOnChange(e.target.value);
                }}
                onBlur={(e) => {
                    handleOnBlur(e.target.value);
                }}
                error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
            />
        </>
    );
}
